import React from 'react'
import './Overview.css';

const AboutOverview = () => {
    return (
        <article className="about-overview">
            <h1>Rugby-Bundesligaausschuss (RBA)</h1>

            <h2>Allgemein</h2>
            <p>Der Rugby-Bundesligaausschuss (RBA) ist ein Gremium innerhalb von Rugby Deutschland, dem nationalen Dachverband für Rugby in Deutschland. Der Ausschuss setzt sich aus Vertretern der 26 Bundesligavereine sowie Verbandsrepräsentanten zusammen und ist für die Organisation und Verwaltung des Spielbetriebs in der 1. und 2. Rugby-Bundesliga verantwortlich.</p>
            <p>Zu den Hauptaufgaben des RBA gehören die Planung und Durchführung des Spielbetriebs, die Beratung des Präsidiums bei der Vergabe von Lizenzen an die teilnehmenden Vereine sowie die Organisation von Endspielen, wie beispielsweise die Ausrichtung des Finales um die Deutsche Meisterschaft. Der Ausschuss arbeitet eng mit Rugby Deutschland zusammen, um einen reibungslosen Ablauf der Wettbewerbe sicherzustellen und die Weiterentwicklung des Rugbysports in Deutschland zu fördern.</p>

            <h2>Organisation und Struktur</h2>

            <h3>Mitgliedschaft</h3>
            <p>Der RBA setzt sich aus je einem Vertreter jedes an den Bundesligen teilnehmenden Vereins sowie den Mitgliedern des RBA-Vorstands zusammen.</p>

            <h3>Vorstand</h3>
            <p>Der Vorstand des RBA besteht aus dem Vorsitzenden, dem stellvertretenden Vorsitzenden, dem stellvertretenden Vorsitzenden für den 15er-Spielbetrieb und dem stellvertretenden Vorsitzenden für den 7er-Spielbetrieb. Der Vorsitzende ist zudem Mitglied des Präsidiums des DRV und vertritt den RBA nach außen.</p>

            <h2>Aufgaben und Zuständigkeiten</h2>

            <h3>Spielbetrieb</h3>
            <p>Der RBA ist verantwortlich für die Organisation und Durchführung des bundesweiten Herren-Vereinsspielbetriebs im 15er- und 7er-Rugby. Dies umfasst die Erstellung von Spielplänen unter Berücksichtigung des DRV-Rahmenspielplans, die Überwachung der Einhaltung geltender Richtlinien und Ordnungen sowie die Prüfung und Archivierung von Spielformularen.</p>

            <h3>Regelwerke</h3>
            <p>Der RBA beschließt eigenständig alle die Bundesligen betreffenden Angelegenheiten und ist dabei an die Weisungen des Deutschen Rugby-Tages (DRT) oder außerordentlichen DRT (ADRT) gebunden.</p>

            <h3>Lizenzierung</h3>
            <p>Der RBA berät das Präsidium bei der Vergabe der Lizenzen an die teilnehmenden Vereine und stellt sicher, dass alle Anforderungen für den Spielbetrieb erfüllt sind.</p>

            <h3>Endspiele</h3>
            <p>Der Ausschuss organisiert zentrale Veranstaltungen wie das Finale um die Deutsche Meisterschaft im 15er-Rugby der Männer.</p>

            <h3>Sitzungen und Beschlussfassung</h3>
            <p>Die Mitglieder des RBA treffen sich mindestens zweimal jährlich zu Sitzungen, deren Termine vom Ausschuss selbst festgelegt werden.</p>

            <p>Durch diese Struktur und Aufgabenverteilung gewährleistet der Rugby-Bundesligaausschuss einen geordneten und fairen Ablauf des Bundesliga-Spielbetriebs und trägt maßgeblich zur Weiterentwicklung des Rugbysports in Deutschland bei.</p>
        </article>
    )
}

export default AboutOverview;
